import dateFunctions, { isDateValid } from "../modules/definition/calendar/dateFunctions";
import { setItemEarliestEndDate, setItemPreferredEndDate } from "../modules/items/reducers/byId/itemDates/setEndDate";
import { setItemLatestStartDate } from "../modules/items/reducers/byId/itemDates/setItemLatestStartDate";
import { setItemPreferredStartDate } from "../modules/items/reducers/byId/itemDates/setItemPreferredStartDate";

export const getDatesOnPrecisionChange = (
  newPrecision,
  changeEndDates,
  calendar,
  oldCalendarPickerDates,
  autoAdjustEndDate
) => {
  let calendarPickerDates = oldCalendarPickerDates;

  let datesChanged = false;

  // First, we need to change the start date (always)
  if (
    isDateValid(calendarPickerDates.preferredStartDate) &&
    calendarPickerDates.preferredStartDate.precision !== newPrecision
  ) {
    const newDate = dateFunctions.dateWithChangedPrecision(
      calendar,
      calendarPickerDates.preferredStartDate,
      newPrecision
    );
    calendarPickerDates = setItemPreferredStartDate(calendarPickerDates, newDate, calendar, autoAdjustEndDate, true);
    datesChanged = true;
  }

  // And also the latestStartDate
  if (
    isDateValid(calendarPickerDates.latestStartDate) &&
    calendarPickerDates.latestStartDate.precision !== newPrecision
  ) {
    const newDate = dateFunctions.dateWithChangedPrecision(calendar, calendarPickerDates.latestStartDate, newPrecision);
    calendarPickerDates = setItemLatestStartDate(calendarPickerDates, newDate.timestamp, newDate.precision, calendar);
    datesChanged = true;
  }

  if (changeEndDates) {
    if (
      isDateValid(calendarPickerDates.earliestEndDate) &&
      calendarPickerDates.earliestEndDate.precision !== newPrecision
    ) {
      const newDate = dateFunctions.endDateWithChangedPrecision(
        calendar,
        calendarPickerDates.earliestEndDate,
        newPrecision
      );
      calendarPickerDates = setItemEarliestEndDate(calendarPickerDates, newDate.timestamp, newDate.precision, calendar);
      datesChanged = true;
    }
    if (
      isDateValid(calendarPickerDates.preferredEndDate) &&
      calendarPickerDates.preferredEndDate.precision !== newPrecision
    ) {
      const newDate = dateFunctions.endDateWithChangedPrecision(
        calendar,
        calendarPickerDates.preferredEndDate,
        newPrecision
      );
      calendarPickerDates = setItemPreferredEndDate(
        calendarPickerDates,
        newDate.timestamp,
        newDate.precision,
        calendar
      );
      datesChanged = true;
    }
  }

  return {
    calendarPickerDates: calendarPickerDates,
    datesChanged: datesChanged
  };
};
